import React from 'react';

const Footer = () => {
  return (
    <>
      <section class="contactarea">
        <div class="container">
          <div class="row">
            <div class="contactportion">
              <p>Ready to get back to business?</p>
              <a class="explore-btn" href="https://www.winklix.com/contact">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
      <section class="footer">
        <div class="container">
          <div class="row border-bg">
            <div class="col-sm-3 col-lg-3 col-md-3">
              <h3 class="ftr-head mt-xs-20">Quick Links</h3>
              <ul class="list-unstyled footer-txt">
                <li><a href="https://www.winklix.com/about" target="_blank" title="winklix company overview">About Winklix</a></li>
                <li><a href="https://winklix.com/case-study/" target="_blank" title="winklix portfolio">Portfolio</a></li>
                <li><a href="https://www.winklix.com/jobs" target="_blank" title="">Careers</a></li>
                <li><a href="https://www.winklix.com/technology" target="_blank" title="">Technology</a></li>
                <li><a href="https://www.winklix.com/blog" target="_blank" title="winklix blog">Blog</a></li>
                <li><a href="https://www.winklix.com/#" target="_blank" title="partner">Partner</a></li>
                <li><a href="https://www.winklix.com/contact" target="_blank" title="winklix contact us">Contact us</a></li>

              </ul>
            </div>
            <div class="col-sm-3 col-lg-3 col-md-3">
              <h3 class="ftr-head mt-xs-20">Services</h3>
              <ul class="list-unstyled footer-txt">
                <li><a href="https://www.winklix.com/salesforce" target="_blank" title="banking and finance expertise">Salesforce</a></li>
                <li><a href="https://www.winklix.com/#" target="_blank" title="healthcare industry winklix">Service Now</a></li>
                <li><a href="https://www.winklix.com/#" target="_blank" title="media and entertainment industry">Odoo</a></li>
                <li><a href="https://www.winklix.com/mobile-app-development/" target="_blank" title="mobile app development">Mobile App Development</a></li>
                <li><a href="https://www.winklix.com/artificial-intelligence/" target="_blank" title="mobile app development">Generative AI & ML</a></li>
                <li><a href="https://www.winklix.com/big-data-company" target="_blank" title="big data">Big Data</a></li>
                <li><a href="https://www.winklix.com/#" target="_blank" title="micro services">Micro Services</a></li>
              </ul>
            </div>

            <div class="col-sm-3 col-lg-3 col-md-3">
              <h3 class="ftr-head mt-xs-20">Solution</h3>
              <ul class="list-unstyled footer-txt">
                <li><a href="https://www.winklix.com/salesforce/sales-cloud/" title="blockchain consultant" target="_blank" >Sales Cloud</a></li>
                <li><a href="https://www.winklix.com/salesforce/service-cloud/" title="cloud enablement" target="_blank"> Service Cloud</a></li>
                <li><a href="https://www.winklix.com/salesforce/marketing-cloud/" title="Winklix AWS Consulting">Marketing Cloud</a></li>
                <li><a href="https://winklix.com/salesforce/cpq" title="ai development company" target="_blank">Salesforce CPQ</a></li>
                <li><a href="https://www.winklix.com/salesforce/commerce-cloud/" title="devops consultant" target="_blank" >Salesforce Commerce Cloud</a></li>
                <li><a href="https://www.winklix.com/salesforce/community-cloud/" title="internet of things" target="_blank" >Salesforce Community Cloud</a></li>
                <li><a href="https://www.winklix.com/big-data-company" title="big data development" target="_blank" >Salesforce Agentforce</a></li>
              </ul>
            </div>
            <div class="col-sm-3 col-lg-3 col-md-3">
              <h3 class="ftr-head mt-sm-20">Contact Us</h3>
              <ul className='footer-icons-number' role="list">
                <li>
                  <a href="tel:+1-(347) 746 2125" title="Call Mobile No." aria-label="Call +1-(347) 746 2125">
                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/united-states.webp' alt='United States Mobile Number Icon' /> +1-(347) 746 2125</a>
                </li>
                <li>
                  <a href="tel:+91-8882-31-31-31" title="Call Mobile No." aria-label="Call +91-8882-31-31-31">
                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/india.webp' alt='India Mobile Number Icon' /> +91-8882-31-31-31</a>
                </li>
                <li>
                  <a href="mailto:info@winklix.com" title="Email us" aria-label="Email info@winklix.com">
                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/email.webp' alt='Email Icon' /> info@winklix.com</a>
                </li>
              </ul>
              <ul class="list-inline footer-txt">
                <p class="connect">Connect with us</p><br />
                <li> <a title="Follow us on Twitter" target="_blank" href="https://twitter.com/winklix" aria-label="Visit our Twitter page">
                  <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/twitter.webp' alt='twitter' />
                </a>
                </li>
                <li> <a title="Follow us on Facebook" target="_blank" href="https://www.facebook.com/Winklix/" aria-label="Visit our Facebook page">
                  <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/facebook.webp' alt='facebook' /> </a>
                </li>
                <li>
                  <a title="Follow us on LinkedIn" target="_blank" href="https://www.linkedin.com/company/winklix/?originalSubdomain=in" aria-label="Visit our Linkedin page" rel="">
                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/linkedin.webp' alt='linkedIn' /> </a>
                </li>
                <li>
                  <a title="Follow us on YouTube" target="_blank" href="https://www.youtube.com/channel/UCS9W-DHO95H39gavX8ICcdA" aria-label="Follow us on YouTube" rel="">
                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/footer/youtube.webp' alt='youtube' /> </a>
                </li>
              </ul>
              <ul class="list-inline footer-txt">
                <p class="connect mb-10">Our Presence</p>
                <li>India</li>
                <li>USA</li>
                <li>UK</li>
                <li>UAE</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-8 col-md-8 pd-0" style={{ marginTop: '20px' }}>
              <ul class="footer-nav">
                <li><a href="https://www.winklix.com/privacy">Privacy |&nbsp;</a></li>
                <li><a href="https://www.winklix.com/terms">Terms |&nbsp;</a></li>
                <li><a target="_blank" href="https://winklixfoundation.org">Winklix Foundation |&nbsp;</a></li>
                <li><a href="https://www.winklix.com/sitemap.xml">Sitemap</a></li>
              </ul>
            </div>
            <div class="col-sm-4 col-lg-4 col-md-4 pd-0" style={{ marginTop: '20px' }}>
              <p class="mb0">Copyright © 2014-2025 Winklix LLC.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Footer;